
<div>
    <ColorPicker ref="colorPicker" />
    <b-row>
        <b-col cols="4" style="overflow-y: auto;">
            <div id="fontSettings">
                <b-form @change="onChange" @reset="onReset">
        <!--
          Hide button for capializeOnNewLine as the setting is also disabled
                    <b-form-checkbox
                          v-model="form.capitalizeOnNewLine"
                          >
              Stor bokstav vid ny rad
                    </b-form-checkbox>

        -->
                    <b-row>
                        <b-col cols="3">
                            <div class="pt-2">Typsnitt</div>
                        </b-col>
                        <b-col>
                            <b-form-select
                                v-model="form.family.selected"
                                :options="form.family.options"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <div class="pt-2">Textstorlek</div>
                        </b-col>
                        <b-col>
                            <b-form-input
                                @change="onFontSizeChange"
                                v-model.number="form.size"
                                type="number"
                                min="0"
                                max="200"
                            />
                        </b-col>
                    </b-row>
                    <br />
                    <b-form-group label="Radavstånd">
                        <b-form-radio-group v-model="form.lineHeight">
                            <b-form-radio
                                v-for="(
                                    lineHeight, indexOpt
                                ) in form.lineHeights"
                                :value="lineHeight"
                                :key="indexOpt"
                                >{{ lineHeight }}</b-form-radio
                            >
                        </b-form-radio-group>
                    </b-form-group>
                    <b-form-group label="Text- och bakgrundsfärg">
                        <b-form-radio-group v-model="form.colorID" stacked>
                            <b-form-radio
                                v-for="(colors, indexOpt) in colorOptions"
                                :value="colors.value"
                                :key="indexOpt"
                            >
                                <b-badge
                                    class="m-0 p-2"
                                    :style="{
                                        backgroundColor:
                                            colors.colors.background,
                                        color: colors.colors.foreground,
                                    }"
                                >
                                    <span style="width: 100%">
                                        <strike
                                            v-if="
                                                indexOpt == 6 &&
                                                !form.customColors.valid
                                            "
                                            >{{ colors.text }}</strike
                                        >
                                        <span v-else>{{
                                            colors.text
                                        }}</span>
                                        <b-icon-brush
                                            style="margin-left: 30px"
                                            v-if="indexOpt == 6"
                                            @click="editColorScheme"
                                            v-b-tooltip.hover
                                            title="Tryck för att välja färgkombination"
                                        />
                                    </span>
                                </b-badge>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <!--
                    <b-row>
                    <b-col>
                    Marginaler
                    </b-col>
                    <b-col>
                    <div class="float-right">
                        <b-form-checkbox
                            v-model="form.margins.linked"
                            @change="onMarginLinkedChange"
                            >Länka</b-form-checkbox
                        >
                    </div>
                    </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols=3>Vänster</b-col>
                      <b-col>
                        <b-form-input
                            @change="onMarginChange"
                            type="number"
                            min="0"
                            max="200"
                            v-model.number="form.margins.left"
                        />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols=3>Topp</b-col>
                      <b-col>
                        <b-form-input
                        @change="onMarginChange"
                        type="number"
                        min="0"
                        max="200"
                        v-model.number="form.margins.top"
                        /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols=3>
                    Höger
                      </b-col>
                      <b-col>
                    <b-form-input
                        @change="onMarginChange"
                        type="number"
                        min="0"
                        max="200"
                        v-model.number="form.margins.right"
                        /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols=3>
                        Botten
                      </b-col>
                      <b-col>
                    <b-form-input
                        @change="onMarginChange"
                        type="number"
                        min="0"
                        max="200"
                        v-model.number="form.margins.bottom"
                        />
                      </b-col>
                    </b-row>
                    -->
                </b-form>
            </div>
        </b-col>
        <b-col>
            <h4>Förhandsgranskning</h4>
            <div
                class="fontPreview"
                :style="{
                    fontFamily: this.form.family.selected,
                    fontSize: this.form.size + 'px',
                    backgroundColor: this.background,
                    color: this.foreground,
                    lineHeight: this.form.lineHeight,
                    paddingLeft: this.form.margins.left + 'px',
                    paddingTop: this.form.margins.top + 'px',
                    paddingRight: this.form.margins.right + 'px',
                    paddingBottom: this.form.margins.bottom + 'px',
                    overflow: 'hidden',
                }"
                v-html="lorem"
            />
        </b-col>
    </b-row>
</div>
